<template>
    <MostPopularSlider
        id="slider"
        ref="slider"
        :key="sliderData.keyData"
        :key-data="sliderData.keyData"
        :slides="sliderData.slides"
        :line-id="sliderData.lineId"
        :skeleton="sliderData.skeleton"
        :limit-items="sliderData.limitItems"
        :config="sliderData.config"
        :class="{'vod-slides': !isEmptySlider}"
        @slide-up="slideUp"
        @slide-down="slideDown"
        @on-item-selected="onListItemSelected"
        @ready="ready"
    />
</template>

<script setup lang="ts">
    import type { MostPopularSlideData, MostPopularSliderRef, sliderProps } from "../../MostPopularSlider/types";
    import { AppConstants } from "@/common";
    import { type Ref, type PropType, ref, computed } from 'vue';
    import MostPopularSlider from "@/components/MostPopularSlider/MostPopularSlider.vue";
    import type { ExposeInterface } from "./types";

    const emit = defineEmits(['slide-up', 'slide-down', 'on-item-selected', 'ready']);

    const props = defineProps({
        slides: {
            type: [Array, null] as PropType<MostPopularSlideData[] | null>,
            required: true,
        }
    });

    const slider: Ref<MostPopularSliderRef | null>= ref(null);
        
    const isEmptySlider = computed((): boolean => {
        return props.slides && props.slides.length == 0 ? true : false;
    });
    const sliderData = computed((): sliderProps => ({
        keyData: 'mostPopular',
        slides: props.slides,
        lineId: 'mostPopular',
        skeleton: 'MostPopularSkeleton',
        limitItems: AppConstants.ItemsInLine,
        config: {
            'isAutoplay': true,
            'speedAutoplay': 5000,
        }
    }));

    const slideUp = (): void => {
        emit('slide-up');
    };
    const slideDown = (): void => {
        emit('slide-down');
    };
    const onListItemSelected = (event: {item: MostPopularSlideData; lineId: string}): void => {
        emit("on-item-selected", event);
    };
    const ready = () => {
        emit('ready', {'isEmptySlider': isEmptySlider.value});
    };
    const focusMostPopular = (): void => {
        if (slider.value) {
            slider.value.focusSlider();
        }
    };
    
    defineExpose<ExposeInterface>({
        focusMostPopular
    });

</script>
